<script setup>
  import { onMounted } from "vue";
  import { onBeforeRouteUpdate, useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { useMCampaignStore } from "@stores/mCampaign";
  import { useMCampaignTargetsStore } from "@stores/mCampaignTargets";
  import { useMCampaignQuotasStore } from "@stores/mCampaignQuotas";

  const route = useRoute();
  const mCampaignStore = useMCampaignStore();
  const { currentMCampaign } = storeToRefs(mCampaignStore);
  const targetsStore = useMCampaignTargetsStore();
  const quotasStore = useMCampaignQuotasStore();

  const resetStores = () => {
    targetsStore.campaignTargets = [];
    quotasStore.campaignQuotas = [];
  };

  const fetchData = async (token) => {
    if (currentMCampaign.value?.token !== token) await mCampaignStore.fetchMCampaign(token);
    await Promise.all([
      targetsStore.fetchMCampaignTargets(token),
      quotasStore.fetchMCampaignQuota(currentMCampaign.value.survey_token),
    ]);
  };

  resetStores();
  onMounted(() => fetchData(route.params.token));
  onBeforeRouteUpdate(async (to, from) => {
    if (to.params.token !== from.params.token) {
      resetStores();
      await fetchData(to.params.token);
    }
  });
</script>

<template>
  <RouterView :key="$route.params.token" />
</template>
